<p-toast></p-toast>
<!-- <ngx-ui-loader [fgsSize]="75" bgsColor="black" fgsColor="grey" fgsPosition="center-center" fgsType="ball-spin-clockwise"></ngx-ui-loader> -->

<!-- Common Popup -->
<app-common-popup 
    [(visible)]="showCommonPopup" 
    [title]="popupTitle"
    [message]="popupMessage"
    (close)="closeCommonPopup()">
</app-common-popup>

<router-outlet></router-outlet>


<!--Codacy--> 